import React from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Delete } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { Autocomplete } from '@totalsoft/rocket-ui';

const EvaluatedAttributeListItemComponent = ({ index, item, dispatch, isReadOnly }) => {
  const { t } = useTranslation();
  const executionOrderOptions = [
    { id: 0, name: '0' },
    { id: 2, name: '2' }
  ];

  const OnExecutionOrderChanged = (property, propertyValue) => {
    dispatch({
      type: 'OnExecutionOrderChanged',
      property,
      propertyValue,
      index
    });
  };

  const onDeleteEvaluatedAttribute = () => {
    dispatch({
      type: 'OnDeleteEvaluatedAttribute',
      engineScoringXAttributeId: item.engineScoringXAttributeId,
      engineAttributeId: item.engineAttributeId
    });
  };

  return (
    <TableRow hover>
      <TableCell>{item.engineAttribute.orderNo}</TableCell>
      <TableCell>{item.engineAttribute.attributeName}</TableCell>
      <TableCell>{item.engineAttribute.description}</TableCell>
      <TableCell>{item.engineAttribute.expression}</TableCell>
      <TableCell>
        <Tooltip title={t('Tooltips.EngineScoringGrid.ExecutionOrderText')} placement='top'>
          <span>
            <Autocomplete
              fullWidth
              isDisabled={isReadOnly}
              value={item.executionOrder}
              simpleValue
              options={executionOrderOptions}
              onChange={event => OnExecutionOrderChanged('executionOrder', event)}
            />
          </span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip title={t('Tooltips.EngineScoringGrid.Delete')}>
          <span>
            <IconButton color='primary' onClick={onDeleteEvaluatedAttribute} disabled={isReadOnly}>
              <Delete />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EvaluatedAttributeListItemComponent.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};

export default EvaluatedAttributeListItemComponent;
